import { RootState } from 'store';
import {
  useCallback,
  useMemo
} from 'react';

import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone,
  checkIsLoadingError
} from 'common/utils/checkLoading';

import { STATIONS_STATE } from '../../constants';

export const useFavouriteStations = () => {
  const favouriteStations = useSelector((state: RootState) => state[STATIONS_STATE].favouriteStations.data);
  return favouriteStations;
};

export const useCheckIsExistFavouriteStationByStationCode = () => {
  const favouriteStations = useFavouriteStations();

  const checkIsExistFavouriteStation = useCallback((stationCode: string = '') => (
    !!(favouriteStations || []).find(item => item.stationCode === stationCode)
  ), [favouriteStations]);

  return checkIsExistFavouriteStation;
};

export const useIsExistFavouriteStationByStationCode = (stationCode: string = '') => {
  const favouriteStations = useFavouriteStations();

  const isExistFavouriteStation = useMemo(() => (
    !!(favouriteStations || []).find(item => item.stationCode === stationCode)
  ), [
    favouriteStations,
    stationCode
  ]);

  return isExistFavouriteStation;
};

const useFavouriteStationsLoadingStatus = () => {
  const favouriteStationsLoadingStatus = useSelector((state: RootState) => state[STATIONS_STATE].favouriteStations.loadingStatus);
  return favouriteStationsLoadingStatus;
};

export const useIsFavouriteStationsLoading = () => {
  const favouriteStationsLoadingStatus = useFavouriteStationsLoadingStatus();
  return checkIsLoading(favouriteStationsLoadingStatus);
};

export const useIsFavouriteStationsDone = () => {
  const favouriteStationsLoadingStatus = useFavouriteStationsLoadingStatus();
  return checkIsLoadingDone(favouriteStationsLoadingStatus);
};

export const useIsFavouriteStationsError = () => {
  const favouriteStationsLoadingStatus = useFavouriteStationsLoadingStatus();
  return checkIsLoadingError(favouriteStationsLoadingStatus);
};

export const useAddingFavouriteStationsLoadingStatus = () => {
  const addingFavouriteStationsLoadingStatus = useSelector((state: RootState) => state[STATIONS_STATE].favouriteStations.addingStatus);
  return addingFavouriteStationsLoadingStatus;
};

export const useIsAddingFavouritStationsLoading = () => {
  const addingFavouriteStationsLoadingStatus = useAddingFavouriteStationsLoadingStatus();
  return checkIsLoading(addingFavouriteStationsLoadingStatus);
};

export const useIsAddingFavouritStationsDone = () => {
  const addingFavouriteStationsLoadingStatus = useAddingFavouriteStationsLoadingStatus();
  return checkIsLoadingDone(addingFavouriteStationsLoadingStatus);
};

export const useFavouriteStationsDeletingStatus = () => {
  const favouriteStationsDeletingStatus = useSelector((state: RootState) => state[STATIONS_STATE].favouriteStations.deletingStatus);
  return favouriteStationsDeletingStatus;
};

export const useIsDeletingFavouritStationsLoading = () => {
  const favouriteStationsDeletingStatus = useFavouriteStationsDeletingStatus();
  return checkIsLoading(favouriteStationsDeletingStatus);
};

export const useIsDeletingFavouritStationsDone = () => {
  const favouriteStationsDeletingStatus = useFavouriteStationsDeletingStatus();
  return checkIsLoadingDone(favouriteStationsDeletingStatus);
};
